import { useMemo, useState, useEffect } from "react";
import {
  Grid,
  makeStyles,
  Slider as MuiSlider,
  Typography,
} from "@material-ui/core";
import { COLORS } from "../../theme/colors";
import { TransparentTextInput } from "./TextInput";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
  },
  rail: {
    height: 8,
    color: "#E7E7E7",
    borderRadius: 4,
  },
  track: {
    height: 8,
    borderRadius: 4,
    color: ({ color }) => color,
  },
  thumb: {
    height: 15,
    width: 15,
    backgroundColor: COLORS.white,
    border: `0.5px solid ${COLORS.darks[0][50]}`,
    boxShadow: "0px 4px 4px 0px #00000040",
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
    "&:after": {
      width: 15,
      height: 15,
      backgroundColor: "#E9E9E9",
      borderRadius: 0,
      transform: "rotate(45deg)",
      top: -20,
      left: -1,
      zIndex: 0,
    },
  },
  mark: {
    top: "80%",
    transform: "rotate(45deg) translate(-3px, 4px)",
    width: 15,
    height: 15,
  },
  markActive: {
    opacity: 1,
    backgroundColor: COLORS.darks[0][100],
  },
  markLabel: {
    color: COLORS.darks[0][100],
    backgroundColor: COLORS.white,
    paddingLeft: theme.spacing(1.8),
  },
  valueLabelContainer: {
    border: "1px solid #E9E9E9",
    padding: `${theme.spacing(0.3)}px ${theme.spacing(0.8)}px`,
    width: "fit-content",
    borderRadius: theme.spacing(0.5),
    position: "relative",
    left: "30%",
    zIndex: 1,
    backgroundColor: COLORS.white,
  },
}));

export const Slider = ({ color, value, defaultValue, max, unit, onChange }) => {
  max = max || 100;
  unit = unit || "%";
  const classes = useStyles({ color });
  const [currentValue, setCurrentValue] = useState(value);

  const currentPercentage = useMemo(() => {
    return ((currentValue / max) * 100).toFixed(0);
  }, [currentValue, max]);

  useEffect(() => setCurrentValue(value), [value]);

  return (
    <>
      <Grid
        className={classes.valueLabelContainer}
        container
        alignItems="center"
        style={{
          left: `${
            currentPercentage -
            (currentValue + "").length * 4 -
            (unit + "").length * 2
          }%`,
        }}
      >
        <TransparentTextInput
          value={currentValue + ""}
          width={(currentValue + "").length * 8.5}
          type="number"
          textAlign="left"
          fontSize={14}
          onChange={(v) => {
            let value = v;
            if (v > max) {
              value = max;
            }
            if (!v) {
              value = 0;
            }
            value = parseFloat(value);
            setCurrentValue(value);
            onChange(null, v);
          }}
        />
        <Typography>{unit}</Typography>
      </Grid>
      <MuiSlider
        value={currentValue}
        classes={{
          root: classes.root,
          rail: classes.rail,
          track: classes.track,
          thumb: classes.thumb,
          markLabel: classes.markLabel,
          mark: classes.mark,
          markActive: classes.markActive,
        }}
        defaultValue={defaultValue}
        onChange={(e, v) => {
          setCurrentValue(v);
          onChange(e, v);
        }}
        step={1}
        max={max}
        marks={[
          {
            value: defaultValue,
            label: `Now: ${((defaultValue / max) * 100).toFixed(0)}%`,
          },
        ]}
      />
    </>
  );
};

Slider.defaultProps = {
  onChange: () => {},
}
